import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-step7-ticket',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step7-ticket.component.html',
  styleUrl: './step7-ticket.component.scss'
})
export class Step7TicketComponent implements OnInit, OnDestroy {
  ticketNumber: string = '';
  countdown: number = 40; // 40 segundos para refrescar
  private countdownInterval: any;

  ngOnInit() {
    this.generateTicketNumber();
    this.startCountdown();
  }

  ngOnDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  private generateTicketNumber(): void {
    // Generar una letra aleatoria (A-Z)
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const randomLetter = letters.charAt(Math.floor(Math.random() * letters.length));

    // Generar números aleatorios (00-99)
    const randomNumbers = Math.floor(Math.random() * 100).toString().padStart(2, '0');

    this.ticketNumber = `${randomLetter}${randomNumbers}`;
  }

  private startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      this.countdown--;

      if (this.countdown <= 0) {
        // Refrescar la página cuando llegue a 0
        window.location.reload();
      }
    }, 1000);
  }
}
